<template>
  <div class="loan-success-wrap">
    <van-image
        :src="require('../../assets/loan/sucicon.png')"
      />
    <h3>恭喜，您的申请已成功提交</h3>  
    <h6>请耐心等待平台合作机构的服务人员来电</h6>
    <p>特别提醒</p>
    <div class="loan-leftp">
      <p>*平台承诺不会向用户收取任何费用，以官方名义收款行为都是诈骗。</p>
      <p>*贷款到账前以卡号错误、流水不足等理由收取“验资费”、“解冻费用"等行为都是诈骗，请拒绝付费，谨防被骗。</p>
      <p>*致电人员均属平台合作的第三方金融机构。</p>
      <p>*如需帮助请联系我们： <a href="https://tb.53kf.com/webCompany.php?arg=10173585&style=1&device=android">点击联系客服</a></p>
    </div>
    <van-button type="info" color="#0294FF" round plain block @click="goBack">确定</van-button>
    <!-- <van-button v-if="recwayData === '1'" type="info" color="#0294FF" round block :to="'/loan/exclusive?channel_lable='+channel_lable">专属优选产品推荐</van-button> -->
  </div>
</template>
<script>
import { Image as VanImage, Button } from 'vant'
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      channel_lable: window.localStorage.getItem('channel'),
      type: this.$route.query.type
    }
  },
  created() {
    window.localStorage.removeItem('loanParams')
    window.localStorage.removeItem('loanPriceData')
    window.localStorage.removeItem('baseInfoData')
    this.handleCommon()
  },
  methods: {
    ...mapActions(['fetchCommon']),
    goBack() {
      // const token = window.localStorage.getItem('token')
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
      // if(!token) {
      //   this.$router.push('/loan?channel_lable=' + this.channel_lable)
      // }else {
      //   if(this.type === 'order') {
      //     this.$router.push('/order?channel_lable=' + this.channel_lable+ '&token=' + token)
      //   }else {
      //     if(isAndroid) {
      //       window.Android.finish()
      //     }
      //     if(isIOS) {
      //       window.webkit.messageHandlers.applyFinish.postMessage(null)
      //     }
      //   }
      // }
      if(isAndroid) {
        window.Android.finish()
      }
      if(isIOS) {
        window.webkit.messageHandlers.applyFinish.postMessage(null)
      }
      // this.$router.push('/loan?channel_lable=' + this.channel_lable)
    },
    handleCommon() {
      // this.fetchCommon({
      //   request: 'loan/showrecway',
      //   path: 'loan/showrecway',
      //   data: {
      //     channel_id: this.channel_lable 
      //   }
      // })
    },
  },
  computed: {
    ...mapState({
      // recwayData(state) {
      //   // console.log(state.common['loan/showrecway'].data)
      //   return state.common['loan/showrecway'].data
      // }
    }),
  },
  components: {
    [VanImage.name]: VanImage,
    [Button.name]: Button
  }
}
</script>
